import { render } from "./PasswordForgetPage.vue?vue&type=template&id=114cf3fc"
import script from "./PasswordForgetPage.vue?vue&type=script&lang=js"
export * from "./PasswordForgetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__